module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-5-256e26da2013bedd42590b5eb4d28001.jpg";